import React from 'react';
import clsx, { ClassValue } from 'clsx';
import styles from './card.module.styl';
type ExperimentPageSummaryCardProps = {
  header: React.ReactNode;
  className?: ClassValue;
  bodyClassName?: ClassValue;
  children?: React.ReactNode;
};
export const ExperimentPageSummaryCard = (props: ExperimentPageSummaryCardProps) => {
  return <div className={clsx(styles.card, props.className)} data-sentry-component="ExperimentPageSummaryCard" data-sentry-source-file="card.tsx">
      <div className={styles.cardHeader}>{props.header}</div>
      <div className={clsx(styles.cardBody, props.bodyClassName)}>{props.children}</div>
    </div>;
};